import React, { useCallback, useState } from 'react';
import { windowIsDefined } from 'app/helpers/windowIsDefined';
import { desktopContentWidth } from 'app/styles/media';
import { fetchNextPlayers, updatePlayerStatsAlltimeSortmodel } from 'app/components/team/playerstats/TeamPlayerStatsActions';
import PlayerStatsGrid from 'app/components/team/playerstats/PlayerStatsGrid';
const MOBILE_OFFSET = 254;
const PAGE_SIZE = 15;
export default function PlayerStatsAlltimeGrid(_ref) {
  var _meta$total;
  let {
    data,
    loadData,
    dispatch
  } = _ref;
  const {
    players: playersData,
    isFetching,
    error,
    sortModel
  } = data;
  const {
    data: players,
    links,
    meta
  } = playersData !== null && playersData !== void 0 ? playersData : {
    data: [],
    links: null,
    meta: null
  };
  const isDesktop = windowIsDefined && window.innerWidth >= desktopContentWidth;
  const [paginationModel, setPaginationModel] = useState({
    page: meta !== null && meta !== void 0 && meta.currentPage ? meta.currentPage - 1 : 0,
    pageSize: PAGE_SIZE
  });
  const calcMaxHeight = useCallback(() => {
    if (windowIsDefined && window.innerWidth < desktopContentWidth) {
      return window.innerHeight - MOBILE_OFFSET;
    }
    if (!players.length || error) {
      return 350;
    }
    return '100%';
  }, [players, error]);
  const fetchNext = useCallback(function () {
    let add = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (links !== null && links !== void 0 && links.next) {
      fetchNextPlayers(links.next, add)(dispatch);
    }
  }, [links, dispatch]);
  const fetchPrev = useCallback(() => {
    if (links !== null && links !== void 0 && links.prev) {
      fetchNextPlayers(links.prev, false)(dispatch);
    }
  }, [links, dispatch]);
  const handleSortModelChange = React.useCallback(newSortModel => {
    dispatch(updatePlayerStatsAlltimeSortmodel(newSortModel));
    setPaginationModel({
      page: 0,
      pageSize: PAGE_SIZE
    });
    const sortQuery = newSortModel.map(sortValue => "".concat(sortValue.sort === 'desc' ? '-' : '').concat(sortValue.field === 'penalties' ? 'penaltiesHit' : sortValue.field)).join(',');
    loadData('alltime', true, sortQuery);
  }, [dispatch]);
  const handlePaginationModelChange = newPaginationModel => {
    if (newPaginationModel.page < paginationModel.page) {
      fetchPrev();
    } else {
      fetchNext();
    }
    setPaginationModel(newPaginationModel);
  };
  const handleScrollEnd = React.useCallback(() => {
    if (isDesktop) {
      return;
    }
    fetchNext(true);
  }, [fetchNext, isDesktop]);
  return /*#__PURE__*/React.createElement(PlayerStatsGrid, {
    type: "alltime",
    players: players,
    isLoading: isFetching,
    error: error,
    calcMaxHeight: calcMaxHeight,
    withTopEleven: false,
    getRowHeight: () => 54,
    hideFooter: !isDesktop,
    pageSizeOptions: [PAGE_SIZE],
    pagination: isDesktop,
    paginationMode: "server",
    rowCount: (_meta$total = meta === null || meta === void 0 ? void 0 : meta.total) !== null && _meta$total !== void 0 ? _meta$total : 0,
    paginationModel: paginationModel,
    onPaginationModelChange: handlePaginationModelChange,
    sortingMode: "server",
    sortModel: sortModel,
    onSortModelChange: handleSortModelChange,
    onRowsScrollEnd: handleScrollEnd,
    "data-sentry-element": "PlayerStatsGrid",
    "data-sentry-component": "PlayerStatsAlltimeGrid",
    "data-sentry-source-file": "PlayerStatsAlltimeGrid.tsx"
  });
}